import type { Infer } from 'superstruct';
import { array, integer, object } from 'superstruct';

export const EditUserRolesDto = object({
	roles: array(object({ id: integer() })),
});

export type EditUserRolesDto = Infer<typeof EditUserRolesDto>;
